export class Constants {
  static Routes = {
    HOME: "/",
    UNAUTHORIZED: "/unauthorized",
  };
  static ImportMapKeys = {
    NOT_FOUND: "not-found",
    UNAUTHORIZED: "unauthorized",
  };
}
